<div class="row" >
    <div class="card">
      <div class="card-body">
        <form [formGroup]="merchantstatusform" (ngSubmit)="CustomerWalletStatusChange(merchantstatusform.value)">
          <div class="row">
            <div class="col-sm-12">
              <div class="mb-12">
                <label class="form-label">Customer Wallet Status<i style="color: red;">*</i></label>
                <select class="form-select" aria-label="Default select example" formControlName="Status" placeholder="Select Customer Status"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.Status.errors}">
                        <option value="null" [disabled]="true" >Select Customer Wallet Status</option>
                        <option value="ACTIVE" *ngIf="walletStatus !== 'ACTIVE'">Activate</option>
                        <option value="BLOCKED" *ngIf="walletStatus !== 'BLOCKED'">Block</option>
                        <!-- <ng-container *ngIf="!showLimitedStatus"> -->
                          <option value="CLOSED" *ngIf="walletStatus !== 'CLOSED'">Close</option>
                          <option value="SUSPENDED" *ngIf="walletStatus !== 'SUSPENDED'">Suspend</option>
                          <option value="RESUBMIT" *ngIf="walletStatus !== 'RESUBMIT'">Resubmit</option>
                        <!-- </ng-container> -->
                </select>
                <div *ngIf="isForm1Submitted && form1.Status.errors?.required" class="invalid-feedback">
                  Please fill this field
                </div>
                <div *ngIf="form1.Status.value === 'CLOSED'" class="text-danger mt-1">
                  <strong>Warning:</strong> Closing this customer is permanent and cannot be undone or reverted back.
                </div>
                <div *ngIf="walletStatus === 'CLOSED'" class="text-danger mt-1">
                  <strong>Note:</strong> This customer is permanently closed and its status can no longer be changed.
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-12">
              <label for="exampleFormControlTextarea1">Remark<i style="color: red;">*</i></label>
              <textarea class="form-control" rows="3" formControlName="Remark"
                        [ngClass]="{'is-invalid': isForm1Submitted && form1.Remark.errors}" maxlength="200"></textarea>
              <div *ngIf="isForm1Submitted && form1.Remark.errors?.required" class="invalid-feedback">
                Please fill this field
              </div>
              <div *ngIf="isForm1Submitted && form1.Remark.errors?.twoSpaces" class="invalid-feedback">
                More than two consecutive spaces are not allowed
              </div>
            </div>
          </div>

          <div class="row mt-3 ">
            <div class="col-md-4">
              <button type="submit" class="btn btn-lg btn-primary"
              [disabled]="this.loading || walletStatus === 'CLOSED'">
                <span  id="loading" role="status" aria-hidden="true"></span>
                Submit</button>
            </div>
          </div>

        </form>
        <hr>
        <div class="row d-flex">
          <div class="form-group col-md-12 " >
              <div class="row mb-0" style="min-height: 220px">
                  <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                    <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
                      [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                       [rowData]="auditData" [rowModelType]="" [rowSelection]="'single'"
                      [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                    </ag-grid-angular>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>

